var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusLed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.border {\n\t\t\t\tfill: rgba(255,255,255,0.75);\n\t\t\t}\n\t\t"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "main",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "border",
    d: "M9865,10927a12,12,0,1,1,8.485-3.515A11.918,11.918,0,0,1,9865,10927Zm0-20a8,8,0,1,0,8,8A8.007,8.007,0,0,0,9865,10907Z",
    transform: "translate(-9853 -10903)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLed);
export default __webpack_public_path__ + "static/media/statusLed.72f094c0b6228e4d603c42541fb4074e.svg";
export { ForwardRef as ReactComponent };